import React, { Fragment } from "react";
import * as _ from "lodash";
import { Grid, Typography } from "@material-ui/core";
import HeaderCashiar from "./HeaderCashiar";
import BodyCashair from "./BodyCashair";
import TotalsCashair from "./TotalsCashair";
import TotalsCashairCar from "./TotalsCashairCar";

function NewCashairCon(props) {
    const { locInv, found, sta, inv, data, onUnmountComplete, premiApp } = props;

    return (
        <Typography component="div" justifyContent='center'>
            <Grid container item justifyContent='center'>
                <Fragment>
                    <HeaderCashiar found={found} sta={sta} locInv={locInv} onUnmountComplete={onUnmountComplete} />
                    <BodyCashair
                        data={data ?? []}
                        onUnmountComplete={onUnmountComplete}
                        locInv={locInv}
                    />
                   {premiApp?.cashirTemplate == 5 ? (
                         <TotalsCashairCar found={found} inv={inv} sta={sta} locInv={locInv} onUnmountComplete={onUnmountComplete} />
                    ) : (
                       <TotalsCashair found={found} inv={inv} sta={sta} locInv={locInv} onUnmountComplete={onUnmountComplete} />
                    )}
                </Fragment>
            </Grid>
        </Typography>
    );
}
export default NewCashairCon;
